export const createRemoveFromString = (strToRemove: string) => {
  const pattern = new RegExp(`(.+)(${strToRemove}.*)`);
  return (str: string) => {
    return str.replace(pattern, '$1');
  };
};

export const removeDetailsFromLocation = createRemoveFromString('/details/');
